import { render, staticRenderFns } from "./Wordlocations.vue?vue&type=template&id=559a23a7&"
import script from "./Wordlocations.vue?vue&type=script&lang=js&"
export * from "./Wordlocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports